// Copyright (c) Docugami, Inc. All rights reserved.

import { AppDispatch, AppState } from '..';
import { DgmlPageResourceRequest, dgmlSlice } from "store/dgml/dgmlSlice";
import { folderIdSelector, pagesInfoSelector } from "store/dgml/dgmlSelectors";
import { frontendSlice } from 'store/frontend/frontendSlice';

export const isPageImageLoaded = (fileId: string, page: number) => (dispatch: AppDispatch, getState: () => AppState) => {
    const state = getState();
    return !!frontendSlice.endpoints.getPageImage.select({fileId: fileId, page: page})(state).isSuccess;
}

export const isPageTokensLoaded = (folderId: string, page: number, version: string) => (dispatch: AppDispatch, getState: () => AppState) => {
    const fid = folderIdSelector(folderId)!;
    if (!fid) {
        throw new Error("Failed to parse folderId");
    }

    const state = getState();
    const queryData: DgmlPageResourceRequest = {
        docsetId: fid.clusterId,
        fileId: fid.fileId,
        page: page,
        version: version
    };

    const pagesInfo = pagesInfoSelector(fid.clusterId, fid.fileId, version)(state)?.data;
    const pageInfo = pagesInfo?.value[page - 1];
    if (!!pageInfo && !pageInfo.tokensInfo) {
        return true;
    }

    const queryState = dgmlSlice.endpoints.getTokenLocations.select(queryData)(state);
    return queryState.isSuccess || queryState.isError;
}
